import { render, staticRenderFns } from "./ModalUserDiscount.vue?vue&type=template&id=027520b5&scoped=true&"
import script from "./ModalUserDiscount.vue?vue&type=script&lang=js&"
export * from "./ModalUserDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ModalUserDiscount.vue?vue&type=style&index=0&id=027520b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027520b5",
  null
  
)

export default component.exports